<ng-container *ngIf="archiveFolder !== undefined else emptyTemplate">
    <span id="entity-modal-label" class="sr-only">{{ archiveFolder.title }}</span>
    <div class="wrapper" [ngClass]="{'en': (currentLanguage | async)=== 'en'}">
        <div class="tab-view-container">
            <app-tablet-view-tabs [detailsView]="detailsView"
                (viewChanged)="onViewChanged($event)"></app-tablet-view-tabs>
        </div>
        <div class="content" [ngClass]="{'map-view': detailsView === eDetailsView.Map}">
            <div class="details-content">
                <app-scientific-archive-folder-details [details]="archiveFolder" [currentLanguage]="currentLanguage$" (viewDocument)="OnViewDocument($event)"
                    (viewFolder)="OnViewFolder($event)"></app-scientific-archive-folder-details>
            </div>
    <div class="map-container">
    <app-arcgis-map [shapes]="shapes" [mapControls]="mapControls"></app-arcgis-map>
    </div>
            </div>
        </div>
        <div class="error">{{ errorMessage }}</div>
        <div class="action">
            <!-- <div class="action-header">
                <h4>{{ 'iaa.aria.additionalAction' | translate}}</h4>
            </div> -->
            <div>
                <p-button [tabindex]="0" [ariaLabel]="'iaa.aria.btnDownloadDoc' | translate" styleClass="icon-button" [link]="true"
                    icon="pi pi-download" [label]="'iaa.aria.btnDownloadDoc' | translate" (keydown.enter)="handleZip()" [disabled]="!archiveFolder?.folderHasScannedFiles" 
                    (click)="handleZip()"/>
            </div>
        </div>
</ng-container>
<ng-template #emptyTemplate>
    <p-messages closable="false" styleClass="custom-error" />
    <app-skeleton-document *ngIf="!hasError"></app-skeleton-document>
</ng-template>